import { useQuery } from "react-query";
import { listOk2goStatus } from "../../api/server";
import moment from "moment";

/**
 * Custom hook for fetching data based on given parameters.
 *
 * @param {string} activeSection - The active section of the application.
 * @param {string} activeBranch - The currently selected branch.
 * @param {object} page - Pagination information.
 * @param {string} activeDate - The currently selected date.
 * @param {string} api - The currently selected api.
 * @returns {object} An object containing the query data, loading state, and a refetch function.
 */
export const useCustomQuery = (
  activeSection,
  activeBranch,
  page,
  activeDate,
  api
) => {
  return useQuery(
    [activeSection, activeBranch, page, activeDate],
    async () => {
      const scopePrefix = `branches/${activeBranch}/`;
      let statusPage = { ...page };
      if (activeSection === "schedules") {
        const year = moment(activeDate).year();
        const month = moment(activeDate).month() + 1;

        const newFilter = {
          ...statusPage.filter, // Spread the existing filter properties
          freeText: null,
          $and: [
            ...(Array.isArray(statusPage.filter?.$and)
              ? statusPage.filter.$and
              : []),
            { month: { $eq: month } },
            { year: { $eq: year } },
          ],
        };

        statusPage = { ...statusPage, filter: newFilter };
      }

      const params = { ...statusPage, scopePrefix };
      const response = await listOk2goStatus(params, activeSection);
      return response?.data || {};
    },
    {
      staleTime: 0,
      enabled:
        activeBranch !== null && activeBranch !== undefined && api !== "revaha", //temporary
    }
  );
};
